<template>
  <v-app>
    <router-view :key="$route.fullPath">
    </router-view>
  </v-app>
</template>


<script>
export default {
  name:"App",
   data: () => ({
    //
  }),
  created(){
  if (JSON.parse(localStorage.getItem('nightmode')) == true){
       this.$vuetify.theme.dark = true
    } else{
       this.$vuetify.theme.dark = false
    }
}
}




</script>

<style lang="scss">

p,h1,h2,div,a,.v-text,.v-btn,.v-card,.v-text-field{
  font-family:'DM Sans'
}
.v-btn{
text-transform:none !important
}

</style>
